import React from "react";
import Drawer from "@mui/material/Drawer";
import { Box } from "@mui/material";
import { Link } from "react-router-dom";
import i18next from "i18next";
import { BasicSelect as TransLang } from "./TransLang";

export default function NavDrawer({ setDrawer, drawer, logoUrl, pages }) {
    let lng = i18next.language;
    const isRtl = lng === "ar";

    return (
        <Drawer
            anchor={isRtl ? "left" : "right"}
            open={drawer}
            onClose={() => setDrawer(false)}
            sx={{
                ".MuiDrawer-paper": {
                    width: "75%",
                    bgcolor: "#FFFFFF",
                    overflowY: "auto",
                },
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    p: 3,
                    gap: 2,
                }}
            >
                <Link
                    to="/"
                    onClick={() => setDrawer(false)}
                    style={{ textDecoration: "none", width: 60 }}
                >
                    {logoUrl ? (
                        <Box
                            component="img"
                            src={logoUrl}
                            alt="logo"
                            sx={{ width: "100%" }}
                        />
                    ) : (
                        <Box sx={{ color: "#1A1A1A", fontWeight: 700, fontSize: 18 }}>
                            Logo
                        </Box>
                    )}
                </Link>
                {pages?.map((page, i) => (
                    <Link
                        key={i}
                        to={page.path}
                        onClick={() => setDrawer(false)}
                        style={{
                            textDecoration: "none",
                            fontSize: 16,
                            fontWeight: 500,
                            color: "#1A1A1A",
                            padding: "8px 0",
                            borderBottom: "1px solid #E8E1D4",
                        }}
                    >
                        {lng === "ar" ? page.name : page.name_en}
                    </Link>
                ))}
                <Box sx={{ mt: 2 }}>
                    <TransLang />
                </Box>
            </Box>
        </Drawer>
    );
}
